// extracted by mini-css-extract-plugin
module.exports = {"galleryimage":"Gallery_galleryimage__-E0_l","gallery":"Gallery_gallery__oYHvH","images":"Gallery_images__1G8pt","gallerytitles":"Gallery_gallerytitles__2GWct"};